import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/gajewsky/code/smooth-ui/website/node_modules/smooth-doc/src/layouts/docs.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "migrate-from-v10"
    }}><a parentName="h1" {...{
        "href": "#migrate-from-v10",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Migrate from v10`}</h1>
    <p>{`Smooth UI v11 is a big breaking change and the migration from v10 could be difficult. This guide will help you achieve it.`}</p>
    <h2 {...{
      "id": "previous-documentation"
    }}><a parentName="h2" {...{
        "href": "#previous-documentation",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Previous documentation`}</h2>
    <p>{`The previous documentation is still accessible and will remain accessible on this url:`}</p>
    <p><a parentName="p" {...{
        "href": "https://smooth-ui-v10.smooth-code.com"
      }}>{`https://smooth-ui-v10.smooth-code.com`}</a></p>
    <h2 {...{
      "id": "system"
    }}><a parentName="h2" {...{
        "href": "#system",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`System`}</h2>
    <p><inlineCode parentName="p">{`@smooth-ui/system`}</inlineCode>{` is replaced by `}<a parentName="p" {...{
        "href": "https://www.smooth-code.com/open-source/xstyled/"
      }}><inlineCode parentName="a">{`@xstyled/system`}</inlineCode></a>{`. The behaviour is the same and everything is documented.`}</p>
    <h2 {...{
      "id": "normalize"
    }}><a parentName="h2" {...{
        "href": "#normalize",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Normalize`}</h2>
    <ul>
      <li parentName="ul">{`No breaking change.`}</li>
    </ul>
    <h2 {...{
      "id": "theming"
    }}><a parentName="h2" {...{
        "href": "#theming",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Theming`}</h2>
    <p>{`Smooth UI v11 follows `}{`[xstyled theme specification]`}{`(`}<a parentName="p" {...{
        "href": "https://www.smooth-code.com/open-source/xstyled/docs/theme-specification/"
      }}>{`a new theme specification`}</a>{`).`}</p>
    <p><inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` has no breaking change, it still uses the one provided either by `}<inlineCode parentName="p">{`styled-component`}</inlineCode>{` or by `}<inlineCode parentName="p">{`emotion-theming`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "emotion"
    }}><a parentName="h2" {...{
        "href": "#emotion",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Emotion`}</h2>
    <p>{`Smooth UI v11 is still compatible with emotion.`}</p>
    <h2 {...{
      "id": "forms"
    }}><a parentName="h2" {...{
        "href": "#forms",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Forms`}</h2>
    <p>{`Form layouts have been reimplemented to improve accessibility, `}<a parentName="p" {...{
        "href": "https://www.smooth-code.com/open-source/smooth-ui/docs/form/"
      }}>{`see new `}<inlineCode parentName="a">{`Form`}</inlineCode>{` documentation`}</a>{`.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`FormGroup`}</inlineCode>{` becomes `}<inlineCode parentName="li">{`FormField`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Label`}</inlineCode>{` becomes `}<inlineCode parentName="li">{`FormFieldLabel`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`control`}</inlineCode>{` prop is no longer required`}</li>
    </ul>
    <h2 {...{
      "id": "grid"
    }}><a parentName="h2" {...{
        "href": "#grid",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Grid`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Grid`}</inlineCode>{` is gone, you can reimplement it:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// Example of a custom \`Grid\` component
const Grid = styled.div\`
  margin: 0 auto;
  max-width: 800px;
  padding: 0 20px;
\`
`}</code></pre>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Row`}</inlineCode>{` and `}<inlineCode parentName="li">{`Col`}</inlineCode>{` are now available everywhere as `}<inlineCode parentName="li">{`row`}</inlineCode>{` and `}<inlineCode parentName="li">{`col`}</inlineCode>{` property, `}<a parentName="li" {...{
          "href": "https://www.smooth-code.com/open-source/xstyled/docs/system-props/#xgrids"
        }}>{`see xstyled documentation`}</a>{`.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// v10
import { Grid, Row, Col } from '@smooth-ui/core-sc'

function Example() {
  return (
    <Grid>
      <Row>
        <Col xs={12} md={4}>
          One
        </Col>
        <Col xs={12} md={4}>
          Two
        </Col>
        <Col xs={12} md={4}>
          Three
        </Col>
      </Row>
    </Grid>
  )
}

// v11
import { Box } from '@smooth-ui/core-sc'

function Example() {
  return (
    <Box mx="auto" px={20} maxWidth={800}>
      <Box row>
        <Box col={{ xs: 1, md: 4 / 12 }}>One</Box>
        <Box col={{ xs: 1, md: 4 / 12 }}>Two</Box>
        <Box col={{ xs: 1, md: 4 / 12 }}>Three</Box>
      </Box>
    </Box>
  )
}
`}</code></pre>
    <h2 {...{
      "id": "components"
    }}><a parentName="h2" {...{
        "href": "#components",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Components`}</h2>
    <h3 {...{
      "id": "alert"
    }}><a parentName="h3" {...{
        "href": "#alert",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Alert`}</h3>
    <p>{`No breaking change, you have nothing to migrate.`}</p>
    <h3 {...{
      "id": "box"
    }}><a parentName="h3" {...{
        "href": "#box",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Box`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Box`}</inlineCode>{` comes now from `}<a parentName="li" {...{
          "href": "https://www.smooth-code.com/open-source/xstyled/docs/system-components/#use-the-box-component"
        }}>{`@xstyled/system`}</a>{` but for convenience it is also re-exported from `}<inlineCode parentName="li">{`@smooth-ui/core-sc`}</inlineCode>{` and `}<inlineCode parentName="li">{`@smooth-ui/core-em`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`It implements `}<a parentName="li" {...{
          "href": "https://www.smooth-code.com/open-source/xstyled/docs/theme-specification/"
        }}>{`a new theme specification`}</a></li>
    </ul>
    <h3 {...{
      "id": "button"
    }}><a parentName="h3" {...{
        "href": "#button",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Button`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Button`}</inlineCode>{` uses `}<a parentName="li" {...{
          "href": "https://reakit.io/docs/button/"
        }}>{`Reakit Button`}</a>{` to improve its accessibility`}</li>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`size`}</inlineCode>{` is now `}<inlineCode parentName="li">{`scale`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "checkbox"
    }}><a parentName="h3" {...{
        "href": "#checkbox",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Checkbox`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Checkbox`}</inlineCode>{` uses `}<a parentName="li" {...{
          "href": "https://reakit.io/docs/checkbox/"
        }}>{`Reakit Checkbox`}</a>{` to improve its accessiblity`}</li>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`size`}</inlineCode>{` is now `}<inlineCode parentName="li">{`scale`}</inlineCode></li>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`valid`}</inlineCode>{` is now `}<inlineCode parentName="li">{`aria-invalid`}</inlineCode>{` (inversed)`}</li>
    </ul>
    <h3 {...{
      "id": "formcheck"
    }}><a parentName="h3" {...{
        "href": "#formcheck",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`FormCheck`}</h3>
    <ul>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`inline`}</inlineCode>{` is gone, you can now use `}<inlineCode parentName="li">{`aria-orientation`}</inlineCode>{` on `}<inlineCode parentName="li">{`RadioGroup`}</inlineCode>{` or `}<inlineCode parentName="li">{`CheckboxGroup`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "input"
    }}><a parentName="h3" {...{
        "href": "#input",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Input`}</h3>
    <ul>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`size`}</inlineCode>{` is now `}<inlineCode parentName="li">{`scale`}</inlineCode></li>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`valid`}</inlineCode>{` is now `}<inlineCode parentName="li">{`aria-invalid`}</inlineCode>{` (inversed)`}</li>
    </ul>
    <h3 {...{
      "id": "modal"
    }}><a parentName="h3" {...{
        "href": "#modal",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Modal`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Modal`}</inlineCode>{` is gone, you have to implement your own with `}<a parentName="li" {...{
          "href": "https://reakit.io/docs/dialog/"
        }}>{`Reakit Dialog`}</a></li>
    </ul>
    <h3 {...{
      "id": "popover"
    }}><a parentName="h3" {...{
        "href": "#popover",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Popover`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Popover`}</inlineCode>{` is gone, you have to implement your own with `}<a parentName="li" {...{
          "href": "https://reakit.io/docs/popover/"
        }}>{`Reakit Popover`}</a></li>
    </ul>
    <h3 {...{
      "id": "radio"
    }}><a parentName="h3" {...{
        "href": "#radio",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Radio`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Radio`}</inlineCode>{` uses `}<a parentName="li" {...{
          "href": "https://reakit.io/docs/radio/"
        }}>{`Reakit Radio`}</a>{` to improve its accessiblity`}</li>
      <li parentName="ul">{`It now requires a `}<inlineCode parentName="li">{`RadioGroup`}</inlineCode>{` and a `}<inlineCode parentName="li">{`useRadioState`}</inlineCode>{` to work`}</li>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`size`}</inlineCode>{` is now `}<inlineCode parentName="li">{`scale`}</inlineCode></li>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`valid`}</inlineCode>{` is now `}<inlineCode parentName="li">{`aria-invalid`}</inlineCode>{` (inversed)`}</li>
    </ul>
    <h3 {...{
      "id": "select"
    }}><a parentName="h3" {...{
        "href": "#select",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Select`}</h3>
    <ul>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`size`}</inlineCode>{` is now `}<inlineCode parentName="li">{`scale`}</inlineCode></li>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`valid`}</inlineCode>{` is now `}<inlineCode parentName="li">{`aria-invalid`}</inlineCode>{` (inversed)`}</li>
    </ul>
    <h3 {...{
      "id": "switch"
    }}><a parentName="h3" {...{
        "href": "#switch",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Switch`}</h3>
    <ul>
      <li parentName="ul">{`The inner component has changed, if you style it, you have to adapt it`}</li>
    </ul>
    <h3 {...{
      "id": "textarea"
    }}><a parentName="h3" {...{
        "href": "#textarea",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Textarea`}</h3>
    <ul>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`size`}</inlineCode>{` is now `}<inlineCode parentName="li">{`scale`}</inlineCode></li>
      <li parentName="ul">{`Property `}<inlineCode parentName="li">{`valid`}</inlineCode>{` is now `}<inlineCode parentName="li">{`aria-invalid`}</inlineCode>{` (inversed)`}</li>
    </ul>
    <h3 {...{
      "id": "tooltip"
    }}><a parentName="h3" {...{
        "href": "#tooltip",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Tooltip`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Tooltip`}</inlineCode>{` is gone, you have to implement your own with `}<a parentName="li" {...{
          "href": "https://reakit.io/docs/tooltip/"
        }}>{`Reakit Tooltip`}</a></li>
    </ul>
    <h3 {...{
      "id": "typography"
    }}><a parentName="h3" {...{
        "href": "#typography",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Typography`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Typography`}</inlineCode>{` is gone, you have to implement your own`}</li>
    </ul>
    <h2 {...{
      "id": "utilities"
    }}><a parentName="h2" {...{
        "href": "#utilities",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Utilities`}</h2>
    <h3 {...{
      "id": "breakpoint"
    }}><a parentName="h3" {...{
        "href": "#breakpoint",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Breakpoint`}</h3>
    <p>{`The utility has been removed, you can do it with a `}<inlineCode parentName="p">{`Box`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// v10
<Breakpoint down="md">
  Displayed down to md
</Breakpoint>

// v11
<Box display={{ md: 'none' }}>
  Displayed down to md
</Box>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// v10
<Breakpoint up="md">
  Displayed up to md
</Breakpoint>

// v11
<Box display={{ xs: 'none', md: 'block' }}>
  Displayed up to md
</Box>
`}</code></pre>
    <h3 {...{
      "id": "switchstate"
    }}><a parentName="h3" {...{
        "href": "#switchstate",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`SwitchState`}</h3>
    <p><inlineCode parentName="p">{`SwitchState`}</inlineCode>{` is gone, use directly `}<a parentName="p" {...{
        "href": "https://reakit.io/docs/checkbox/"
      }}>{`Reakit Checkbox`}</a>{` to implement the same kind of behaviour.`}</p>
    <h3 {...{
      "id": "toggler"
    }}><a parentName="h3" {...{
        "href": "#toggler",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Toggler`}</h3>
    <p><inlineCode parentName="p">{`Toggler`}</inlineCode>{` is gone, use `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/hooks-state.html"
      }}>{`React.useState`}</a>{` instead.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// v10
import { Toggler } from '@smooth-ui/core-sc'

function Example() {
  return (
    <Toggler defaultToggled>
      {([toggled, onToggle]) => (
        <Button onClick={onToggle}>{toggled ? 'ON' : 'OFF'}</Button>
      )}
    </Toggler>
  )
}

// v11
import React from 'react'

function Example() {
  const [toggled, setToggled] = React.useState(true)
  return (
    <Button onClick={() => setToggled(x => !x)}>
      {toggled ? 'ON' : 'OFF'}
    </Button>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "styled--css"
    }}><a parentName="h3" {...{
        "href": "#styled--css",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`styled & css`}</h3>
    <p><inlineCode parentName="p">{`styled`}</inlineCode>{` and `}<inlineCode parentName="p">{`css`}</inlineCode>{` are no longer exported from `}<inlineCode parentName="p">{`@smooth-ui/core-sc`}</inlineCode>{` / `}<inlineCode parentName="p">{`@smooth-ui/core-em`}</inlineCode>{`, you can import them from from `}<inlineCode parentName="p">{`@xstyled/styled-components`}</inlineCode>{` / `}<inlineCode parentName="p">{`@xstyled/emotion`}</inlineCode>{` if you want to use it.`}</p>
    <p><strong parentName="p">{`Styled Components:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// v10
import { styled, css } from '@smooth-ui/core-sc'

// v11
import styled, { css } from '@xstyled/styled-components'
`}</code></pre>
    <p><strong parentName="p">{`Emotion:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// v10
import { styled, css } from '@smooth-ui/core-em'

// v11
import styled, { css } from '@xstyled/emotion'
`}</code></pre>
    <h3 {...{
      "id": "th"
    }}><a parentName="h3" {...{
        "href": "#th",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`th`}</h3>
    <p><inlineCode parentName="p">{`th`}</inlineCode>{` utility is now exported from `}<inlineCode parentName="p">{`@xstyled/system`}</inlineCode>{` and `}<a parentName="p" {...{
        "href": "https://www.smooth-code.com/open-source/xstyled/docs/system-utilities/#theme-getters"
      }}>{`it is improved`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// v10
import { th } from '@smooth-ui/core-sc'

// v11
import { th } from '@xstyled/system'
`}</code></pre>
    <h3 {...{
      "id": "unit-px"
    }}><a parentName="h3" {...{
        "href": "#unit-px",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`unit, px`}</h3>
    <p><inlineCode parentName="p">{`unit`}</inlineCode>{` and `}<inlineCode parentName="p">{`px`}</inlineCode>{` are not longer exported. Use `}<inlineCode parentName="p">{`th.px`}</inlineCode>{` instead.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// v10
import { th } from '@smooth-ui/core-sc'

css\`
  font-size: \${px(10)};
\`

// v11
import { th } from '@xstyled/system'

css\`
  font-size: \${th.px(10)};
\`
`}</code></pre>
    <h3 {...{
      "id": "up-down-between"
    }}><a parentName="h3" {...{
        "href": "#up-down-between",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`up, down, between`}</h3>
    <p>{`Responsive utilities are now exported from `}<inlineCode parentName="p">{`@xstyled/system`}</inlineCode>{`, `}<a parentName="p" {...{
        "href": "https://www.smooth-code.com/open-source/xstyled/docs/system-utilities/#responsive-utilities"
      }}>{`see documentation`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// v10
import { up, down, between } from '@smooth-ui/core-sc'

// v11
import { up, down, between } from '@xstyled/system'
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      